import React from 'react';
import './status.less';

const StatusBlock = (props) => {
  return (
    <div className="footerStatus">
      <div className="d-flex flex-wrap j-content-center">
        <div class="showSatusBlockMain-Top">
          <div className="showSatusBlock">
            <div className="SelectcolorWiseList green w-14"></div>
            <span>
              Available <span className="mx-4px">|</span>
            </span>
          </div>
          <div className="showSatusBlock">
            <div className="SelectcolorWiseList tanOrange w-14"></div>
            <span>
              New Arrival<span className="mx-4px">|</span>
            </span>
          </div>
          <div className="showSatusBlock">
            <div className="SelectcolorWiseList red w-14"></div>
            <span>
              On Hold<span className="mx-4px">|</span>
            </span>
          </div>

          <div className="showSatusBlock">
            <div className="SelectcolorWiseList blue w-14"></div>
            <span>
              On Memo<span className="mx-4px">|</span>
            </span>
          </div>
          <div className="showSatusBlock">
            <div className="SelectcolorWiseList pink w-14"></div>
            <span>Best Buy</span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default StatusBlock;
